import $ from "jquery";
import ymaps from 'ymaps';

class Map {

    Init = () => {

        ymaps.load('https://api-maps.yandex.ru/2.1/?lang=en_RU&amp;').then(ymaps => {
            const MyMap = new ymaps.Map('map', {
                center: $(window).width() <= 980 ? [59.957782064159616,30.342188499999985] : [59.95777130348602,30.345417879653912],
                zoom: 16,
                controls: ['typeSelector',  'fullscreenControl']
            });

            const zoomControl = new ymaps.control.ZoomControl({
                options: {
                    size: "small",
                    position: {
                        bottom: 70,
                        top: 'auto',
                        left: 20
                    }
                }
            });
            MyMap.controls.add(zoomControl);
            MyMap.behaviors.disable('scrollZoom');
            if ('ontouchstart' in window || navigator.maxTouchPoints) {
                MyMap.behaviors.disable('drag');
            }

            const myPlacemark = new ymaps.Placemark([59.957782064159616,30.342188499999985], {
            }, {
                iconLayout: 'default#image',
                iconImageHref: '/dist/img/logo.svg',
                iconImageSize: [92, 92],
                iconImageOffset: [-46, -23],
            });

            MyMap.geoObjects.add(myPlacemark);

            MyMap.events.add('boundschange', function (e) {
                let newZoom = e.get('newZoom'),
                    oldZoom = e.get('oldZoom');
                if (newZoom !== oldZoom) {
                    if(newZoom<15){
                        myPlacemark.options.set('iconImageSize',[20, 20]);
                        myPlacemark.options.set('iconImageOffset',[-10, 0]);
                    }else if(newZoom<16){
                        myPlacemark.options.set('iconImageSize',[40, 40]);
                        myPlacemark.options.set('iconImageOffset',[-22, -5]);
                    }else{
                        myPlacemark.options.set('iconImageSize',[92, 92]);
                        myPlacemark.options.set('iconImageOffset',[-46, -23]);
                    }
                }
            });


        }).catch(error => console.log('Failed to load Yandex Maps', error));

    };
    
}


export default new Map;